import { connect } from 'react-redux'

import { notifyError, dismissAllMessages, notifyWarning } from '../UserMessaging'
import { translateResourceString } from '../../../util/translationUtility';
import { continueCheckout } from './navigationActionCreators';
import { mapStateToContinueOrderDetails } from './mapStateToContinueOrderDetails'

import { validate } from '../Validation/OrderDetailsValidation'
import { orderCanContinueValidators } from '../Validation/OrderValidators';
import { formatMoney } from '../../components'
import CheckoutContinue from './CheckoutContinue'

import {
  selectPaymentOption
} from '../PaymentMethod/paymentMethodActionCreators'

const mapCheckoutContinueStateToProps = (state, ownProps) => {
    var placeOrderDetails = mapStateToContinueOrderDetails(state);
    placeOrderDetails.constants = state.constants; // Hack on the constants object so we can see what constant values are when we validate
    
    return {
        continueButtonText: translateResourceString("/Checkout/Continue/ContinueToPayment"),
        placeOrderDetails: placeOrderDetails,
        onPaymentScreen: state.ui.onPaymentScreen,
        ...ownProps
    }
  }
  
  const orderDetailsCanContinue = (orderDetails) => validate(orderDetails, orderCanContinueValidators);
  
const allowPurchaseOrder = (subTotal, minimumCartValueForPO) => {
    return subTotal >= minimumCartValueForPO;
};
const blockPurhcaseOrderforStopworkshop = (IsStopWorkshop) => {
    return IsStopWorkshop;
};



  const mapCheckoutContinueDispatchToProps = (dispatch) => {
    return {
      onContinueClick: (placeOrderDetails) => {
          dispatch(dismissAllMessages());
          const errors = orderDetailsCanContinue(placeOrderDetails);
          if(errors.length === 0) {
              dispatch(continueCheckout());
              const isPurchaseOrderAllowed = allowPurchaseOrder(placeOrderDetails.SubTotal, placeOrderDetails.constants.minimumCartValueForPO);
              if (!isPurchaseOrderAllowed) {
                  const formatCurrency = formatMoney(placeOrderDetails.Currency);
                  dispatch(notifyWarning(translateResourceString("/Checkout/PaymentInformation/MinimumCartValueForPOMessage").replace("{0}", formatCurrency(placeOrderDetails.constants.minimumCartValueForPO))));
              }
              const isStopworkpoblock = blockPurhcaseOrderforStopworkshop(placeOrderDetails.IsStopWorkshop);
              if (isStopworkpoblock) {
                  dispatch(notifyWarning(translateResourceString("/Checkout/PaymentInformation/StopWorksupportMessage").replace("{0}")));
              }

              const filteredPaymentOptions = placeOrderDetails.PaymentOptions && placeOrderDetails.PaymentOptions.filter(po => po.Name !== "Purchase Order" || (isPurchaseOrderAllowed && !isStopworkpoblock));
              if (filteredPaymentOptions && filteredPaymentOptions.length === 1) {
                  const paymentOption = filteredPaymentOptions[0];
                  dispatch(selectPaymentOption(paymentOption.Id, paymentOption.Name));
              }

          } else {
              const intro = translateResourceString("/Checkout/Continue/Errors/Intro") + ": ";
              const message = errors.reduce((acc, cur) => acc + '\n' + cur, intro);
              dispatch(notifyError(message));
          }
      }
    }
  }
  
  const CheckoutContinueContainer = connect(mapCheckoutContinueStateToProps, mapCheckoutContinueDispatchToProps)(CheckoutContinue);
  
  export default CheckoutContinueContainer
